import React from 'react';
import { cn } from '@/utils';
import Button from './Button';

export interface CodeInputProps {
  value: string;
  onChange: (value: string) => void;
  onSendCode: () => void;
  countdown: number;
  isSending: boolean;
  label?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  leftIcon?: React.ReactNode;
}

const CodeInput = React.forwardRef<HTMLInputElement, CodeInputProps>(
  (
    {
      value,
      onChange,
      onSendCode,
      countdown,
      isSending,
      label,
      error,
      disabled = false,
      className,
      leftIcon,
    },
    ref
  ) => {
    const canSendCode = countdown === 0 && !isSending && !disabled;

    return (
      <div className={cn('flex flex-col gap-1 w-full', className)}>
        {label && (
          <label className="text-sm font-medium text-gray-700">{label}</label>
        )}

        <div className="relative flex gap-2">
          {/* 验证码输入框 */}
          <div className="flex-1 relative">
            {leftIcon && (
              <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                {leftIcon}
              </div>
            )}
            <input
              ref={ref}
              type="text"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder="请输入6位验证码"
              maxLength={6}
              disabled={disabled}
              className={cn(
                'w-full rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 placeholder-gray-400',
                'focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20',
                'disabled:bg-gray-50 disabled:cursor-not-allowed',
                error && 'border-error-500 focus:border-error-500 focus:ring-error-500/20',
                leftIcon && 'pl-10'
              )}
            />
          </div>

          {/* 发送验证码按钮 */}
          <Button
            type="button"
            variant={canSendCode ? 'primary' : 'outline'}
            size="sm"
            onClick={onSendCode}
            disabled={!canSendCode}
            className="flex-shrink-0 whitespace-nowrap"
          >
            {countdown > 0 ? `${countdown}秒后重试` : isSending ? '发送中...' : '获取验证码'}
          </Button>
        </div>

        {error && <p className="text-sm text-error-600">{error}</p>}
      </div>
    );
  }
);

CodeInput.displayName = 'CodeInput';

export default CodeInput;
